exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".goods_info .info[data-v-03615c50]{margin-left:10px}.goods_info .info p[data-v-03615c50]{color:#666666}.goods_info .info p[data-v-03615c50]:first-child{color:#999999}.activity[data-v-03615c50]{line-height:24px}.activity span[data-v-03615c50]{width:20px;height:20px;margin-left:10px}.child_page[data-v-03615c50]{padding:30px}.common_form_search[data-v-03615c50]{padding-top:15px;padding-left:15px;padding-right:15px;background-color:#ffffff;border-bottom:1px solid #eeeeee}\n", ""]);

// exports
